import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output
} from '@angular/core';
import {GetRegion2Css, GetRegion2Name, WORD_LIST_MEANING} from '../../defines/client.const';
import {SimpleDialect} from '../../models/dialect.model';

@Component({
  selector: 'app-link-popup-item-dialect',
  templateUrl: './link-popup-item-dialect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkPopupItemDialectComponent implements AfterViewInit {
  @HostBinding('style.display') styleBlock = 'block';
  @HostBinding('class') class = 'tooltip-item';
  @Input() dialect?: SimpleDialect;
  @Input() showMoreBtn = true; // 더보기 버튼 표시 여부
  @Output() close = new EventEmitter<string | null>();
  @Output() afterViewInit = new EventEmitter<void>();

  protected readonly GetRegion2Name = GetRegion2Name;
  protected readonly GetRegion2Css = GetRegion2Css;

  ngAfterViewInit() {
    this.afterViewInit.emit();
  }

  protected onGotoDetail($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(this.dialect?.id);
  }

  protected onClose($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(null);
  }


  protected getMoreMeanings(dialect: SimpleDialect): number {
    // const more = Math.max(0, (word?.meaning?.length ?? 0) - WORD_LIST_MEANING - 1)
    // console.warn('getMoreMeanings() ', more);
    return Math.max(0, (dialect?.meaning2?.length ?? 0) - WORD_LIST_MEANING - 1); // -1 = 기본 뜻의 갯수는 뺀다.
  }
}
